const goalMain = {
  title: 'OUR MISSION',
  paragraphs: [
    'To turn Ukrainian technology into a reliable weapon that helps save the lives of defenders and provide an advantage on the battlefield.',
    'We supply Ukrainian units with strike UAVs that effectively perform combat missions even within an area of active EW interference — in a GPS-denied environment where external control is unavailable.',
  ],
  cards: {
    bpla: {
      title: '1500',
      description: 'UAVs carry out combat missions',
    },
    defence: {
      title: '15M',
      description: 'Cost of the most expensive destroyed target',
    },
    team: {
      title: '100',
      description: 'Units work with us',
    },
  },
}
export default goalMain
